/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {useCallback} from 'react';
import {makeStyles} from '@material-ui/styles';
import EntityLabel from '@ion/core/src/entities/EntityLabel';
import {dlsColor} from '@ion/dls/src/theme/theme';
import useThemeContext from '../../theme/useThemeContext';
import {IconRadioLabel} from '../radio/IconRadioLabel';
import RadioButton from '../radio/RadioButton';
import {AutocompleteSearchResult} from '../search/AutocompleteSearchResult';

interface GroupSelectionProps {
  item: any;
  searchValue: string;
  onViewSubaccounts: Function;
}

const useStyles = makeStyles(() => ({
  labelContainer : {
    width           : '-webkit-fill-available',
    height          : '76px',
    borderRadius    : '12px',
    backgroundColor : dlsColor('grey6')
  }
}));

/**
 * Component to display Global Account Item
 * ```typescript
 *  import GroupSelection from '@ion/dls/src/components/groupchooser/GroupSelection';
 * 
 *  <GroupSelection item={group}
 *   searchValue={searchValue}
 *   onViewSubaccounts={onViewSubaccounts}/>
 * ```
 */
const GroupSelection = ({
  item,
  searchValue,
  onViewSubaccounts
}: GroupSelectionProps) => {
  const classes = useStyles();

  const {
    isCurrent : isCurrentTheme
  } = useThemeContext();

  const onIconClick = useCallback(function(e) {
    e.stopPropagation();
    e.preventDefault();
    onViewSubaccounts(item, true);
  }, [item]);

  return (
    <div className={isCurrentTheme ? classes.labelContainer : ''}>
      <RadioButton value={item.href}
        label={
          <IconRadioLabel label={
            <AutocompleteSearchResult option={{name: EntityLabel.get(item)}}
              searchValue={searchValue}
              highlightColor={dlsColor('lightBlue')} />
          } onIconClick={item.subAccounts ? onIconClick : undefined} />} />
    </div>
  );
};

export default GroupSelection;
